{
  "language": {
    "label": "اللغة",
    "select": "اختر اللغة"
  },
  "nav": {
    "howItWorks": "كيف نعمل",
    "programmes": "البرامج",
    "pricing": "الأسعار",
    "contact": "تواصل معنا",
    "admin": "لوحة الإدارة",
    "resources": "موارد أولياء الأمور",
    "reviews": "آراء أولياء الأمور",
    "signIn": "تسجيل دخول ولي الأمر",
    "portal": "بوابة ولي الأمر",
    "book": "احجز تقييماً مجانياً",
    "terms": "الشروط والأحكام",
    "refund": "سياسة الاسترداد",
    "privacy": "إشعار الخصوصية",
    "tagline": "تعليم إنجليزي متميز عبر الإنترنت للمتعلمين الصغار"
  },
  "hero": {
    "title": "دروس إنجليزية أونلاين للأطفال من 4 إلى 12 عاماً تبني طلاقة حقيقية في التحدث",
    "rating": "معلّمة حاصلة على شهادة CELTA · خريجة اللغة الإنجليزية وعلم النفس",
    "credential": "معلمة معتمدة من CELTA",
    "subtitleBefore": "دروس إنجليزية مباشرة للأطفال من 4 إلى 12 عاماً، بحد أقصى 5 طلاب لكل صف وأكثر من 80% وقت تحدث فعلي. ويُقاس التقدّم وفق",
    "subtitleLink": "منهجنا المتوافق مع إطار CEFR",
    "ctaPrimary": "احجز تقييماً مجانياً",
    "ctaSecondary": "اطّلع على أسعار التسجيل",
    "liveLesson": "درس مباشر · مجموعة A1",
    "imageAlt": "ثلاثة أطفال يضحكون ويتحدثون خلال درس إنجليزي مباشر عبر الإنترنت مع Smart Word Labs"
  },
  "approach": {
    "heading": "مجموعات صغيرة. ثقة كبيرة في التحدث.",
    "link": "تعرّف على طريقتنا خطوة بخطوة"
  },
  "programmes": {
    "heading": "البرامج حسب العمر والمستوى",
    "intro": "يبدأ كل تسجيل بتقييم مجاني وخطة تعلّم مكتوبة. يُوضع الأطفال في مجموعة صغيرة تناسب فئتهم العمرية ومستواهم وفق CEFR، بينما يوفّر برنامج IELTS Mastery تدريباً فردياً خاصاً للمتقدمين من أي عمر.",
    "cefrLabel": "المستوى وفق CEFR",
    "cefr": "CEFR {{level}}",
    "lessonLength": "مدة الدرس",
    "cohortSize": "حجم المجموعة",
    "speakingTime": " · أكثر من 80% وقت تحدث",
    "explore": "استكشف {{title}}",
    "exploreAria": "اطّلع على تفاصيل {{title}} لفئة {{band}}",
    "bookAria": "احجز تقييماً مجانياً في اللغة الإنجليزية لبرنامج {{title}}، {{band}}",
    "book": "احجز تقييماً مجانياً",
    "compareAll": "قارن بين جميع البرامج بالتفصيل",
    "items": {
      "early-phonics-explorers": {
        "band": "من 4 إلى 6 سنوات",
        "title": "مستكشفو الأصوات المبكرة",
        "summary": "دروس إنجليزية مباشرة للأطفال من 4 إلى 6 سنوات: الصوتيات التركيبية والكلمات الأولى وثقة التحدث في مجموعة من خمسة أطفال.",
        "duration": "دروس مدتها 30 دقيقة",
        "cohort": "5 أطفال كحد أقصى",
        "spots": "٥ أطفال كحد أقصى في كل مجموعة"
      },
      "literacy-builders": {
        "band": "من 7 إلى 9 سنوات",
        "title": "بناة القراءة والكتابة",
        "summary": "دروس إنجليزية في مجموعات صغيرة للأطفال من 7 إلى 9 سنوات تشمل طلاقة القراءة والكتابة المنظمة والمحادثة اليومية، وفق مستويي A1–A2.",
        "duration": "دروس مدتها 45 دقيقة",
        "cohort": "5 أطفال كحد أقصى",
        "spots": "٥ أطفال كحد أقصى في كل مجموعة"
      },
      "confident-communicators": {
        "band": "من 10 إلى 12 سنة",
        "title": "المتحدثون الواثقون",
        "summary": "برنامج إنجليزي وفق إطار CEFR للأطفال من 10 إلى 12 سنة يطوّر كتابة المقالات والمناظرة ومهارات المقابلات استعداداً للمرحلة الثانوية.",
        "duration": "دروس مدتها 45 دقيقة",
        "cohort": "5 أطفال كحد أقصى",
        "spots": "٥ أطفال كحد أقصى في كل مجموعة"
      },
      "ielts-mastery": {
        "band": "لجميع الأعمار",
        "title": "إتقان الآيلتس فردي",
        "summary": "تدريب خاص على الآيلتس الأكاديمي أو العام لأي عمر، بجلسات فردية مبنية حول الدرجة المستهدفة وموعد الاختبار.",
        "duration": "دروس مدتها 45 دقيقة",
        "cohort": "فردي",
        "spots": "دروس خاصة فردية"
      }
    }
  },
  "pricing": {
    "heading": "أسعار شهرية بسيطة",
    "headingPage": "أسعار دروس اللغة الإنجليزية أونلاين للأطفال",
    "intro": "رسوم شهرية واحدة لكل طفل، تُدفع شهرياً ويمكن إلغاؤها في أي وقت. درس التقييم وخطة التعلّم مجانيان دائماً.",
    "introTeaser": "رسوم شهرية واحدة لكل طفل، تُدفع شهرياً ويمكن إلغاؤها في أي وقت. التقييم المجاني وخطة التعلّم المكتوبة مشمولان في كل باقة.",
    "mostPopular": "الأكثر شيوعاً",
    "perMonth": "دولار / شهرياً",
    "perLesson": "{{amount}} دولار للدرس الواحد",
    "subscribe": "اشترك الآن",
    "signInToSubscribe": "سجّل الدخول للاشتراك",
    "seeMore": "اطّلع على ما تتضمنه كل باقة في صفحة الأسعار",
    "noteLessonLength": "تختلف مدة الدرس حسب الفئة العمرية: 30 دقيقة لعمر 4–6 سنوات، و45 دقيقة لعمر 7–12 سنة.",
    "noteCohorts": "تُقام الدروس الساعة 9 و10 و11 صباحاً و2 و3 و4 و5 و6 مساءً بتوقيت تورونتو (ET). يتم تأكيد موعدك بالضبط خلال التقييم المجاني.",
    "noteSibling": "تسجيل الأشقاء يوفّر 10% على كل طفل إضافي. الأسعار بالدولار الأمريكي.",
    "tiers": {
      "cohort_starter_monthly": {
        "name": "باقة المجموعة التمهيدية",
        "lessons": "8 دروس شهرياً",
        "cadence": "درسان أسبوعياً",
        "features": [
          "مجموعة صغيرة من 5 أطفال كحد أقصى",
          "دروس مباشرة مدتها 45 دقيقة، مرتان أسبوعياً",
          "واجبات أسبوعية مع ملاحظات المعلمة",
          "تقرير تقدّم شهري وفق CEFR",
          "تواصل مباشر مع المعلمة سلمى",
          "رصيدان لإعادة الجدولة كل شهر"
        ]
      },
      "cohort_intensive_monthly": {
        "name": "باقة المجموعة المكثفة",
        "lessons": "16 درساً شهرياً",
        "cadence": "4 دروس أسبوعياً",
        "features": [
          "مجموعة صغيرة من 5 أطفال كحد أقصى",
          "دروس مباشرة مدتها 45 دقيقة، 4 مرات أسبوعياً",
          "واجبات أسبوعية مع ملاحظات المعلمة",
          "تقرير تقدّم شهري وفق CEFR",
          "تواصل مباشر مع المعلمة سلمى",
          "4 أرصدة لإعادة الجدولة كل شهر",
          "أولوية في توزيع المجموعات"
        ]
      },
      "private_1on1_monthly": {
        "name": "دروس خاصة فردية",
        "lessons": "16 درساً شهرياً",
        "cadence": "4 دروس أسبوعياً",
        "features": [
          "دروس فردية بلا مجموعة — منهج مخصص بالكامل",
          "دروس مباشرة مدتها 45 دقيقة، 4 مرات أسبوعياً",
          "واجبات أسبوعية مع ملاحظات المعلمة",
          "تقرير تقدّم شهري وفق CEFR",
          "تواصل مباشر مع المعلمة سلمى",
          "إعادة جدولة مرنة (بدون حد شهري)",
          "وتيرة تعلّم مصممة حول أهداف الطفل"
        ]
      },
      "ielts_mastery_1on1_monthly": {
        "name": "إتقان الآيلتس فردي",
        "lessons": "16 درساً شهرياً",
        "cadence": "4 دروس أسبوعياً",
        "features": [
          "متاح لجميع الأعمار — بلا حد أقصى للعمر",
          "تحضير موجّه لاختبار الآيلتس الأكاديمي أو العام",
          "دروس فردية بلا مجموعة — استراتيجية مخصصة للوصول للدرجة المستهدفة",
          "جلسات مكثفة مدتها 45 دقيقة تغطي التحدث والقراءة والكتابة والاستماع",
          "تقييمات مفصلة لمهمتي الكتابة الأولى والثانية مع درجات تقديرية",
          "اختبارات تحدث تجريبية فردية مع ملاحظات بأسلوب الممتحن",
          "تدريب موجّه على القراءة والاستماع مع تحليل الأخطاء وإدارة الوقت",
          "تواصل مباشر مع المعلمة سلمى",
          "إعادة جدولة مرنة (بدون حد شهري)",
          "وتيرة تعلّم مصممة حول موعد اختبارك"
        ]
      },
      "starter_pack_onetime": {
        "name": "باقة البداية",
        "lessons": "4 دروس خاصة فردية",
        "cadence": "30 دقيقة لكل درس",
        "features": []
      }
    },
    "oneTime": "دولار لمرة واحدة",
    "getStarterPack": "احصل على باقة البداية",
    "starterNote": "جرّب 4 دروس قبل الالتزام. إذا سجّلت خلال 30 يوماً، يُخصم مبلغ 79 دولاراً كاملاً من شهرك الأول."
  }
}
